/* 证件相关接口 */
import { $post } from '@/api/request'

// 新增
export function add (data = {}) {
  return $post({
    url: '/compPaper/add',
    data
  })
}

// 列表查询
export function query (data = {}) {
  return $post({
    url: '/compPaper/query',
    data
  })
}

// 删除
export function deletePaper (data = {}) {
  return $post({
    url: '/compPaper/delete',
    data
  })
}
// 修改
export function update (data = {}) {
  return $post({
    url: '/compPaper/update',
    data
  })
}
